import { forwardRef, useState } from "react";
import { PinInput } from "@mantine/core";
import { HiEye, HiEyeSlash } from "react-icons/hi2";
import useIsDesktop from "../../../hooks/useIsDesktop";
import { CustomText } from "../CustomText/CustomText";

export const CustomPinInput = forwardRef(
  ({ size, mask = false, ...props }, ref) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "lg" : "md");
    const [revealed, setRevealed] = useState(false);

    if (!mask) {
      return <PinInput ref={ref} size={responsiveSize} {...props} />;
    }

    return (
      <>
        <PinInput ref={ref} size={responsiveSize} mask={!revealed} {...props} />
        <CustomText
          component="button"
          type="button"
          size="xs"
          color="primary"
          onClick={() => setRevealed((r) => !r)}
          className="flex items-center justify-center gap-1 mx-auto hover:underline"
        >
          {revealed ? <HiEyeSlash size={12} /> : <HiEye size={12} />}
          {revealed ? "Hide PIN" : "Show PIN"}
        </CustomText>
      </>
    );
  },
);

CustomPinInput.displayName = "CustomPinInput";
